import {
  segmentTrackProductSoldOutNotifyMe,
  segmentTrackProductComingSoonNotifyMe,
} from 'lib/segment'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { isSoldOut, isWaitlisted } from 'lib/utils/product'
import {
  CTA_KEYS,
  PDP__WARN_SELECT_OPTION_IN_STOCK,
  PDP__WARN_SELECT_OPTION_SOLD_OUT,
  PDP__WARN_SELECT_OPTION_COMING_SOON,
} from './const'

const getOptionCtaKey = (isItemOnWaitlist) =>
  isItemOnWaitlist ? CTA_KEYS.waitlisted : CTA_KEYS.notifyMe

const getCtaKey = (localWaitlists, product, selectedOption) => {
  const { attributes, stock, is_coming_soon } = product
  let ctaKey = CTA_KEYS.addToBag
  const isThereWaitlistItem = attributes?.some(
    (attr) => !isWaitlisted(attr, localWaitlists),
  )

  if (is_coming_soon) {
    if (attributes?.length && !isThereWaitlistItem) return CTA_KEYS.waitlisted
    const isItemOnWaitlist = isWaitlisted(selectedOption, localWaitlists)
    return isItemOnWaitlist ? CTA_KEYS.waitlisted : CTA_KEYS.comingSoon
  }

  if (isSoldOut(selectedOption)) {
    const isItemOnWaitlist = isWaitlisted(selectedOption, localWaitlists)
    ctaKey = getOptionCtaKey(isItemOnWaitlist)
  } else if (!selectedOption && (stock?.is_sold_out || stock?.quantity < 1)) {
    ctaKey = getOptionCtaKey(!isThereWaitlistItem)
  }

  return ctaKey
}

const scrollToNotice = () => {
  const options = document.querySelector('.pdp__options-container')

  if (options) {
    const isSafari = navigator.userAgent.toLowerCase().includes('safari')
    if (isSafari) {
      options.scrollIntoViewIfNeeded(true)
    } else {
      options.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }
}

const noSizeSelectNotice = (ctaKey, setOptionMessage, t) => {
  let locize

  switch (ctaKey) {
    case CTA_KEYS.comingSoon:
      locize = PDP__WARN_SELECT_OPTION_COMING_SOON
      break
    case CTA_KEYS.addToBag:
      locize = PDP__WARN_SELECT_OPTION_IN_STOCK
      break
    default:
      locize = PDP__WARN_SELECT_OPTION_SOLD_OUT
      break
  }

  setOptionMessage(hasLocizeTranslation(t, locize.key, locize.text))
  scrollToNotice()
}

const optionAction = (
  addToBagAction,
  addToWaitlistAction,
  ctaKey,
  doneProcessing,
  localWaitlists,
  product,
  selectedOption,
  setLocalWaitlists,
  showFallback,
  setWaitlistSnackBarOpen,
  onAdded,
) => {
  if (ctaKey === CTA_KEYS.addToBag) {
    let finished = false
    const finish = () => {
      if (finished) return
      finished = true
      doneProcessing()
    }
    const request = addToBagAction({
      enableInterstitial: false,
      onError: finish,
      onSuccess: (cart) => {
        finish()
        onAdded?.(cart)
      },
      ...(onAdded ? { requireQuantityIncrease: true } : {}),
      product,
      sizeData: selectedOption,
      isQuickAddToBag: false,
    })
    // Empty/cancelled responses can settle without either callback.
    // Unlock for a deliberate retry; never retry the cart write automatically.
    if (request?.then) {
      request.then(finish, () => {
        if (!finished) showFallback()
        finish()
      })
    }
  } else if (ctaKey === CTA_KEYS.notifyMe || ctaKey === CTA_KEYS.comingSoon) {
    const segmentData = { product, sizeData: selectedOption }
    const isComingSoon = segmentData?.product?.is_coming_soon

    addToWaitlistAction({
      onError: (e) => {
        doneProcessing()

        if (e !== false) {
          showFallback()
        }
        if (isComingSoon) {
          segmentTrackProductComingSoonNotifyMe(segmentData, null, false)
        } else {
          segmentTrackProductSoldOutNotifyMe(segmentData, null, false)
        }
      },
      onSuccess: (_, sizeId) => {
        setLocalWaitlists({ ...localWaitlists, [sizeId]: true })
        doneProcessing()
        if (isComingSoon) {
          segmentTrackProductComingSoonNotifyMe(segmentData, null, true)
        } else {
          segmentTrackProductSoldOutNotifyMe(segmentData, null, true)
        }
        setWaitlistSnackBarOpen(true)
      },
      product,
      sizeData: selectedOption,
    })
  }
}

export { getCtaKey, noSizeSelectNotice, optionAction }
